/*
  Nalia routine bundles.
  One place for the "add a step / remove a step" cart logic, used by the
  routine section on product pages and by the cart drawer.

  add(key, pageKeys): puts the cheapest mix of bundles and singles for the
  whole routine in the cart, including the page's own product when it is not
  in the cart yet. A bundle already in the cart stays, or is replaced by a
  bigger bundle that contains it.
  remove(key, pageKeys): takes out just that step and puts the rest back the
  cheapest way (e.g. 4 Steps minus Serum = The Triple Threat).

  Lines on a subscription, gift lines (free, or with _ properties) and lines
  with a quantity above one are never removed or replaced.
  Config comes from snippets/nalia-bundle-config.liquid (window.NaliaBundleConfig).
*/
(function () {
  // Cart drawer guard. When the cart was empty at page load, the first add
  // re-renders the drawer while it is opening and it ends up open but not
  // modal: just the "Cart" header bar, no items or checkout button (seen on
  // the live theme too, phone and desktop). Reopening it as a modal fixes it.
  if (!window.__naliaDrawerGuard) {
    window.__naliaDrawerGuard = true;
    var fixDrawer = function () {
      var d = document.querySelector('.cart-drawer__dialog');
      if (d && d.open && !d.matches(':modal')) {
        try { d.close(); d.showModal(); } catch (e) {}
      }
    };
    document.addEventListener('cart:update', function () {
      setTimeout(fixDrawer, 300);
      setTimeout(fixDrawer, 1000);
      setTimeout(fixDrawer, 2000);
    });
  }

  // Routine adds never open the cart drawer. When an add completes the kit,
  // the free gift app puts the Dewy Duo in and then opens the drawer itself
  // (it calls the drawer's open() directly and sends its cart update without
  // the theme's "don't open" flag). For 10 seconds after she taps Add or
  // Remove in the routine, both are kept quiet. Any other tap ends that window
  // at once, so the cart icon, the product page's Add to cart button and
  // edits inside the drawer open it as before.
  if (!window.__naliaQuietGift) {
    window.__naliaQuietGift = true;
    var quietUntil = 0;
    var isQuiet = function () { return Date.now() < quietUntil; };
    document.addEventListener('click', function (e) {
      if (!e.isTrusted) return;
      var t = e.target;
      quietUntil = (t && t.closest && t.closest('.nr [data-nr-add], .nr [data-nr-rm]')) ? Date.now() + 10000 : 0;
    }, true);
    window.addEventListener('cart:update', function (e) {
      var d = e.detail, src = (d && (d.sourceId || (d.data && d.data.source))) || '';
      if (src === 'bogos' && isQuiet() && d) {
        if (d.data) d.data.deferDrawerOpen = true; else d.data = { source: 'bogos', deferDrawerOpen: true };
      }
    }, true);
    if (window.customElements) {
      customElements.whenDefined('cart-drawer-component').then(function () {
        var C = customElements.get('cart-drawer-component');
        if (!C || !C.prototype || typeof C.prototype.open !== 'function' || C.prototype.__naliaQuiet) return;
        var open = C.prototype.open;
        C.prototype.open = function () { if (isQuiet()) return; return open.apply(this, arguments); };
        C.prototype.__naliaQuiet = true;
      });
    }
  }

  // Keep the cart drawer open while she edits it. Changing a line (×, +/-,
  // remove) makes the theme and the gift app re-render the header, which
  // replaces the open drawer with a closed one. For a few seconds after one
  // of those taps, a closed drawer is reopened straight away. Any other tap
  // (close button, backdrop, checkout) or Escape ends that window at once.
  if (!window.__naliaHoldDrawer) {
    var holdUntil = 0, holdWatch = null;
    var reopenDrawer = function () {
      if (Date.now() > holdUntil) return;
      var c = document.querySelector('cart-drawer-component');
      var d = document.querySelector('.cart-drawer__dialog');
      if (!c || !d) return;
      if (!d.open) {
        try { d.showModal(); } catch (e) {}
        if (!d.open && typeof c.open === 'function') { try { c.open(); } catch (e) {} }
      } else if (!d.matches(':modal')) {
        try { d.close(); d.showModal(); } catch (e) {}
      }
    };
    var holdDrawer = function (ms) {
      holdUntil = Date.now() + (ms || 6000);
      if (holdWatch) return;
      holdWatch = new MutationObserver(reopenDrawer);
      holdWatch.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['open'] });
      var stop = function () {
        if (Date.now() < holdUntil) { setTimeout(stop, 500); return; }
        holdWatch.disconnect(); holdWatch = null;
      };
      setTimeout(stop, 500);
    };
    window.__naliaHoldDrawer = holdDrawer;
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var edit = t.closest('.cart-drawer__dialog') && t.closest('[data-nalia-rm], .quantity-minus, .quantity-plus, .cart-items__remove');
      if (edit) holdDrawer(6000); else holdUntil = 0;
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') holdUntil = 0; }, true);
  }

  // Section ids of the cart drawer / cart page, so cart API calls can return
  // the redrawn cart in the same reply (no second request to redraw it).
  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      if (c.dataset.sectionId && ids.indexOf(c.dataset.sectionId) < 0) ids.push(c.dataset.sectionId);
    });
    return ids;
  }

  // Cart: how often, per line (snippets/nalia-cart-plan.liquid). Tapping
  // One-time / 30 days / 60 days moves that line onto the chosen plan, or off
  // any plan, and refreshes the drawer. Works on every page: this file is
  // also loaded site-wide from snippets/nalia-brand-styles.liquid.
  if (!window.__naliaPlan) {
    window.__naliaPlan = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-nalia-plan]');
      if (!b) return;
      var g = b.closest('[data-nalia-plan-group]');
      if (!g) return;
      e.preventDefault();
      e.stopPropagation();
      if (b.getAttribute('aria-pressed') === 'true' || g.classList.contains('is-busy')) return;
      var was = g.querySelector('[aria-pressed="true"]');
      g.classList.add('is-busy');
      g.querySelectorAll('[data-nalia-plan]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      if (window.__naliaHoldDrawer) window.__naliaHoldDrawer(8000);
      // Show the result straight away; Shopify confirms in the background and
      // the drawer redraw that follows replaces these estimates with its own.
      try { planPreview(g, was, b); } catch (err) {}
      var plan = b.getAttribute('data-nalia-plan');
      var body = { id: g.getAttribute('data-key'), quantity: parseInt(g.getAttribute('data-qty'), 10) || 1, selling_plan: plan ? parseInt(plan, 10) : null };
      var planSections = cartSectionIds();
      if (planSections.length) { body.sections = planSections.join(','); body.sections_url = location.pathname; }
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
        .then(function (c) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: c, sourceId: 'nalia-plan', data: { source: 'nalia-plan', itemCount: c.item_count, deferDrawerOpen: true, sections: c.sections } }
          }));
          if (window.__naliaHoldDrawer) window.__naliaHoldDrawer(5000);
        })
        .catch(function () {
          g.classList.remove('is-busy');
          g.querySelectorAll('[data-nalia-plan]').forEach(function (x) { x.setAttribute('aria-pressed', x === was ? 'true' : 'false'); });
          // put the drawer back to what the cart really holds
          fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: c, sourceId: 'nalia-plan', data: { source: 'nalia-plan', itemCount: c.item_count, deferDrawerOpen: true } } }));
          });
        });
    }, true);

    // Instant preview of a plan change, from the prices printed on the buttons
    // (snippets/nalia-cart-plan.liquid): the line price and its crossed-out
    // one-time price, the note beside the quantity, the cart total and the
    // "You save" line in the box.
    var moneyLike = function (text, cents) {
      var n = (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return text.replace(/[\d,]+(\.\d{2})?/, n);
    };
    var planPreview = function (g, oldBtn, newBtn) {
      var oldP = parseInt(oldBtn && oldBtn.getAttribute('data-line-price'), 10);
      var newP = parseInt(newBtn.getAttribute('data-line-price'), 10);
      var oneP = parseInt(g.querySelector('[data-nalia-plan=""]').getAttribute('data-line-price'), 10);
      if (isNaN(oldP) || isNaN(newP) || isNaN(oneP)) return;
      var row = document.querySelector('.cart-items__table-row[data-key="' + g.getAttribute('data-key') + '"]');
      if (row) {
        var cell = row.querySelector('.cart-items__price');
        var main = cell && cell.querySelector('text-component .money, text-component');
        if (main) main.textContent = moneyLike(main.textContent, newP);
        var s = cell && cell.querySelector('s.compare-at-price');
        if (newP < oneP) {
          if (!s && cell) { s = document.createElement('s'); s.className = 'compare-at-price'; s.textContent = moneyLike(main ? main.textContent : '$0.00', oneP); cell.appendChild(s); }
          else if (s) s.textContent = moneyLike(s.textContent, oneP);
        } else if (s) { s.remove(); }
        var qty = row.querySelector('.cart-items__quantity');
        var note = qty && qty.querySelector('.nalia-plan-note');
        var noteText = newBtn.getAttribute('data-note');
        if (noteText && qty) { if (!note) { note = document.createElement('p'); note.className = 'nalia-plan-note'; qty.appendChild(note); } note.textContent = noteText; }
        else if (note) { note.remove(); }
      }
      document.querySelectorAll('.cart-drawer .cart__total .money, .cart__total-value .money').forEach(function (t) {
        var cur = parseInt(t.textContent.replace(/[^\d]/g, ''), 10);
        if (!isNaN(cur)) t.textContent = moneyLike(t.textContent, cur + (newP - oldP));
      });
      var saved = 0;
      document.querySelectorAll('[data-nalia-plan-group]').forEach(function (grp) {
        var one = parseInt(grp.querySelector('[data-nalia-plan=""]').getAttribute('data-line-price'), 10);
        var on = grp.querySelector('[aria-pressed="true"]');
        var p = parseInt(on && on.getAttribute('data-line-price'), 10);
        if (!isNaN(one) && !isNaN(p)) saved += one - p;
      });
      var perk = document.querySelector('.nalia-cart-sub__perk');
      if (perk) {
        perk.classList.toggle('nalia-cart-sub__perk--saved', saved > 0);
        perk.textContent = saved > 0 ? 'You save ' + moneyLike('$0.00', saved) + ' by subscribing' : 'On singles and the Dewy Duo. Skip or cancel any time.';
      }
    };
  }

  if (window.NaliaBundles) return;
  var C = window.NaliaBundleConfig;
  if (!C) return;

  var KEYS = ['cleanser', 'toner', 'serum', 'moisturiser', 'dewy'];
  var bundles = (C.bundles || []).filter(function (b) { return b && b.ok; });
  var byPid = {};
  KEYS.forEach(function (k) {
    var x = C.singles[k];
    if (x) byPid[x.p] = { keys: [k], v: x.v };
  });
  bundles.forEach(function (b) { byPid[b.p] = { keys: b.keys.concat(b.extra || []), v: b.v, bundle: b }; });

  var cart = null, cartAt = 0;
  var HKEY = 'naliaRoutinePulled';
  // The cart is kept in memory: every cart:update that carries the whole
  // cart refreshes it, so an Add can plan straight away instead of asking
  // Shopify first. Older than a minute, or missing, it is read again.
  function isCart(c) { return !!(c && c.items && c.token); }
  var giftAt = 0;
  document.addEventListener('cart:update', function (e) {
    var r = e.detail && e.detail.resource;
    if (isCart(r)) { cart = r; cartAt = Date.now(); }
    var src = e.detail && (e.detail.sourceId || (e.detail.data && e.detail.data.source));
    if (src === 'bogos') giftAt = Date.now();
  });
  function fresh() { return cart && Date.now() - cartAt < 60000 ? Promise.resolve(cart) : read(); }
  // Read the cart in the background as soon as the drawer opens, so a tap on
  // × inside it can save straight away instead of reading the cart first.
  if (window.customElements) {
    customElements.whenDefined('cart-drawer-component').then(function () {
      var D = customElements.get('cart-drawer-component');
      if (!D || !D.prototype || typeof D.prototype.open !== 'function' || D.prototype.__naliaPrime) return;
      var open = D.prototype.open;
      D.prototype.open = function () {
        var r = open.apply(this, arguments);
        if (!cart || Date.now() - cartAt > 30000) { try { read(); } catch (e) {} }
        return r;
      };
      D.prototype.__naliaPrime = true;
    });
  }

  function uniq(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }
  function has(a, x) { return a.indexOf(x) > -1; }
  function pulled() { try { return JSON.parse(sessionStorage.getItem(HKEY) || '{}'); } catch (e) { return {}; } }
  function savePulled(o) { try { sessionStorage.setItem(HKEY, JSON.stringify(o)); } catch (e) {} }

  function analyse(pageKeys) {
    var owned = (pageKeys || []).slice(), units = [], locked = [];
    (cart && cart.items ? cart.items : []).forEach(function (it) {
      var m = byPid[it.product_id];
      if (!m) return;
      owned = owned.concat(m.keys);
      var props = it.properties || {};
      var gift = it.final_line_price === 0 || Object.keys(props).some(function (p) { return p.charAt(0) === '_'; });
      var sub = !!it.selling_plan_allocation;
      if (gift || sub || it.quantity > 1) { locked = locked.concat(m.keys); return; }
      // A bundle's free extra (the kit's Dewy Duo) counts as owned, but is not
      // something she paid for, so it is never rebuilt as a paid line.
      units.push({ keys: m.bundle ? m.bundle.keys.slice() : m.keys, v: it.variant_id, line: it.key, bundle: m.bundle || null });
    });
    var cartKeys = [];
    units.forEach(function (u) { cartKeys = cartKeys.concat(u.keys); });
    return { owned: uniq(owned), units: units, locked: uniq(locked), cartKeys: uniq(cartKeys) };
  }

  // Cheapest exact mix of bundles and singles covering every key in T.
  function cover(T, keep) {
    keep = keep || [];
    var best = null, n = bundles.length;
    for (var mask = 0; mask < (1 << n); mask++) {
      var used = [], items = [], cost = 0, ok = true;
      for (var i = 0; i < n && ok; i++) {
        if (!(mask & (1 << i))) continue;
        var b = bundles[i];
        if (!b.keys.every(function (k) { return has(T, k); })) { ok = false; break; }
        var all = b.keys.concat(b.extra || []);
        if (all.some(function (k) { return has(used, k); })) { ok = false; break; }
        used = used.concat(all); cost += b.price; items.push({ v: b.v, b: b });
      }
      if (ok) {
        var chosen = items.map(function (it) { return it.b; });
        ok = keep.every(function (kb) {
          return chosen.some(function (b) { return b.id === kb.id || kb.keys.every(function (k) { return has(b.keys, k); }); });
        });
      }
      if (!ok) continue;
      T.forEach(function (k) {
        if (!ok || has(used, k)) return;
        var x = C.singles[k];
        if (!x || !x.ok) { ok = false; return; }
        cost += x.price; items.push({ v: x.v, k: k });
      });
      if (!ok) continue;
      if (!best || cost < best.cost || (cost === best.cost && items.length < best.items.length)) best = { cost: cost, items: items };
    }
    return best;
  }

  function diff(a, pick) {
    var target = pick.items.map(function (it) { return it.v; });
    var remove = [], toAdd = target.slice();
    a.units.forEach(function (u) {
      var i = toAdd.indexOf(u.v);
      if (i > -1) toAdd.splice(i, 1); else remove.push(u.line);
    });
    return { add: toAdd, remove: remove };
  }

  function planAdd(key, pageKeys) {
    pageKeys = pageKeys || [];
    var a = analyse(pageKeys);
    var free = function (k) { return !has(a.locked, k); };
    var T1 = uniq(a.cartKeys.concat([key])).filter(free);
    var pageExtra = pageKeys.filter(function (k) { return !has(a.cartKeys, k) && free(k); });
    var T2 = uniq(T1.concat(pageExtra));
    var keep = a.units.filter(function (u) { return u.bundle; }).map(function (u) { return u.bundle; });
    // The product on this page goes in with whatever she adds, if it is not in
    // the cart already: on the Toner page, Add on Cleanser puts in Toner and
    // Cleanser. The cheapest mix still applies, so it becomes a bundle where
    // one fits. If the page's product cannot be sold, only the tapped step goes in.
    var c1 = cover(T1, keep), c2 = pageExtra.length ? cover(T2, keep) : null, pick = c1, pulledIn = [];
    if (c2) { pick = c2; pulledIn = pageExtra; }
    if (!pick) return null;
    var d = diff(a, pick);
    var bundle = null;
    pick.items.forEach(function (it) { if (it.b && has(it.b.keys.concat(it.b.extra || []), key)) bundle = it.b; });
    d.bundle = bundle; d.pulledIn = pulledIn;
    return d;
  }

  // Can this step be taken out again? Only steps that are in the cart as
  // removable lines and are not the product the page is selling.
  function canRemove(key, pageKeys) {
    var a = analyse(pageKeys);
    if (has(pageKeys || [], key) || !has(a.cartKeys, key)) return false;
    var p = planRemove(key, pageKeys);
    return !!(p && (p.add.length || p.remove.length));
  }

  function planRemove(key, pageKeys) {
    var a = analyse(pageKeys);
    // Also take out anything that same Add pulled in with it (the page's own
    // product that went in as part of a bundle), so the cart goes back to how it was.
    var drop = [key].concat(pulled()[key] || []);
    var T = a.cartKeys.filter(function (k) { return !has(drop, k); });
    var pick = T.length ? cover(T, []) : { items: [] };
    if (!pick) return null;
    var d = diff(a, pick);
    d.bundle = null;
    pick.items.forEach(function (it) { if (it.b) d.bundle = it.b; });
    return d;
  }

  function withSections(body) {
    var ids = cartSectionIds();
    if (ids.length) { body.sections = ids.join(','); body.sections_url = location.pathname; }
    return body;
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); });
  }
  function read() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) { cart = c; cartAt = Date.now(); return c; });
  }

  // One save of a plan (adds and removes). The last request asks Shopify for
  // the redrawn cart drawer in the same reply (sections): no second request.
  // When none of the products being added is already in the cart, the adds
  // and removes go as ONE save (/cart/update.js takes variant ids to add and
  // line keys to remove together).
  function save(p) {
    var inCart = function (v) { return cart && cart.items.some(function (it) { return it.variant_id === v; }); };
    var oneSave = !p.add.some(inCart) && uniq(p.add).length === p.add.length;
    var chain;
    if (oneSave) {
      var all = {};
      p.remove.forEach(function (line) { all[line] = 0; });
      p.add.forEach(function (v) { all[v] = 1; });
      chain = post('/cart/update.js', withSections({ updates: all }));
    } else {
      chain = Promise.resolve(null);
      if (p.add.length) {
        var body = { items: p.add.map(function (v) { return { id: v, quantity: 1 }; }) };
        chain = chain.then(function () { return post('/cart/add.js', body); });
      }
      if (p.remove.length) {
        var upd = {};
        p.remove.forEach(function (line) { upd[line] = 0; });
        chain = chain.then(function () { return post('/cart/update.js', { updates: upd }); });
      }
      // An empty update returns the whole cart plus the redrawn drawer.
      chain = chain.then(function () { return post('/cart/update.js', withSections({ updates: {} })); });
    }
    return chain.then(function (c) { cart = c; cartAt = Date.now(); return c; });
  }

  // Tell the page the cart changed (the drawer redraws from c.sections).
  function announce(c, source) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: c, sourceId: source, data: { source: source, itemCount: c.item_count, deferDrawerOpen: true, sections: c.sections } }
    }));
    // The gift app adds or removes the free Dewy Duo a moment later.
    // If the cart changes after that, refresh the drawer once more
    // (not needed when the gift app has already sent its own update).
    var sentAt = Date.now();
    setTimeout(function () {
      if (giftAt > sentAt || window.NaliaCartBusy()) return;
      read().then(function (c2) {
        if (c2.item_count !== c.item_count && !window.NaliaCartBusy()) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: c2, sourceId: 'nalia-refresh', data: { source: 'nalia-refresh', itemCount: c2.item_count, deferDrawerOpen: true } }
          }));
        }
      });
    }, 1500);
  }

  function apply(p, source) {
    return save(p).then(function (c) { announce(c, source || 'nalia-routine'); return c; });
  }

  // Plan from the cart in memory; if Shopify refuses (the cart changed
  // somewhere else meanwhile), read it again and try once more.
  function run(plan, ok, source) {
    return fresh().then(function () {
      var p = plan();
      if (!ok(p)) throw { description: '' };
      return apply(p, source).then(function () { return p; }, function (err) {
        return read().then(function () {
          var p2 = plan();
          if (!ok(p2)) throw err;
          return apply(p2, source).then(function () { return p2; });
        });
      });
    });
  }

  function add(key, pageKeys, source) {
    return run(function () { return planAdd(key, pageKeys); }, function (p) { return !!(p && p.add.length); }, source).then(function (p) {
      return Promise.resolve().then(function () {
        // Remove takes out only the step that was tapped; the page's own
        // product stays in, so nothing is recorded to undo with it.
        var h = pulled();
        delete h[key];
        savePulled(h);
        return p;
      });
    });
  }

  function remove(key, pageKeys, source) {
    return run(function () { return planRemove(key, pageKeys); }, function (p) { return !!(p && (p.add.length || p.remove.length)); }, source).then(function (p) {
      return Promise.resolve().then(function () {
        var h = pulled();
        delete h[key];
        savePulled(h);
        return p;
      });
    });
  }

  // ---------------------------------------------------------------------
  // Instant cart drawer.
  // Taps on × (take a step out of a bundle), + / − and the bin inside the
  // drawer show their result straight away; Shopify saves in the background
  // and the drawer is then redrawn from Shopify's own reply, so anything the
  // prediction got wrong is corrected within a second.
  //
  // Accuracy: a result is only drawn ahead when it can be worked out exactly:
  // no discount codes or automatic discounts on the cart, prices that match
  // what Shopify charges for this market, and new rows taken from rows
  // Shopify pre-renders (sections/nalia-cart-row-templates.liquid). Otherwise
  // the tap shows a loading state and waits for Shopify, as before.
  //
  // Taps are never ignored: they queue and are saved one after another.
  // The drawer is only redrawn from Shopify once the queue is empty, so a
  // reply for an earlier tap can't undo what a later tap is showing.
  // ---------------------------------------------------------------------
  var TPL = null, tplLoading = null;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function loadTemplates() {
    if (TPL) return Promise.resolve(TPL);
    if (tplLoading) return tplLoading;
    tplLoading = fetch(ROOT + '?sections=nalia-cart-row-templates', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j && j['nalia-cart-row-templates'];
        if (!html) throw new Error('no templates');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var box = doc.getElementById('nalia-cart-row-templates');
        if (!box) throw new Error('no templates');
        var t = { currency: box.getAttribute('data-currency'), byV: {}, savings: box.querySelector('template[data-nalia-savings]') };
        box.querySelectorAll('template[data-variant-id]').forEach(function (el) {
          t.byV[el.getAttribute('data-variant-id')] = {
            tpl: el, price: parseInt(el.getAttribute('data-price'), 10), cmp: parseInt(el.getAttribute('data-cmp'), 10) || 0,
            ok: el.getAttribute('data-ok') === '1', pid: parseInt(el.getAttribute('data-product-id'), 10)
          };
        });
        TPL = t;
        return t;
      })
      .catch(function () { tplLoading = null; return null; });
    return tplLoading;
  }

  // Warm up when the drawer opens: the cart (for planning) and the rows.
  if (window.customElements) {
    customElements.whenDefined('cart-drawer-component').then(function () {
      var D = customElements.get('cart-drawer-component');
      if (!D || !D.prototype || typeof D.prototype.open !== 'function' || D.prototype.__naliaInstant) return;
      var open = D.prototype.open;
      D.prototype.open = function () {
        var r = open.apply(this, arguments);
        try { loadTemplates(); } catch (e) {}
        return r;
      };
      D.prototype.__naliaInstant = true;
    });
  }

  // ---- money helpers --------------------------------------------------
  function cents(text) {
    var m = String(text || '').match(/[\d,]+(\.\d{2})?/);
    if (!m) return NaN;
    var n = m[0].replace(/,/g, '');
    return m[1] ? Math.round(parseFloat(n) * 100) : parseInt(n, 10) * 100;
  }
  function moneyIn(text, c) {
    var n = (c / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return String(text).replace(/[\d,]+(\.\d{2})?/, n);
  }
  function setMoney(el, c) {
    if (!el) return;
    var m = el.querySelector('.money') || el;
    m.textContent = moneyIn(m.textContent, c);
    if (el.hasAttribute && el.hasAttribute('value')) el.setAttribute('value', moneyIn(el.getAttribute('value'), c));
  }

  // ---- reading the drawer ---------------------------------------------
  function drawer() { return document.querySelector('.cart-drawer__dialog'); }
  function rowsBody(d) { return d && d.querySelector('cart-items-component tbody'); }
  function rowOf(d, key) {
    var found = null;
    d.querySelectorAll('tr.cart-items__table-row[data-key]').forEach(function (r) { if (r.getAttribute('data-key') === key) found = r; });
    return found;
  }
  function rowNumbers(row, qty) {
    var cell = row && row.querySelector('.cart-items__price');
    if (!cell) return null;
    var line = cents((cell.querySelector('text-component .money') || cell.querySelector('text-component') || {}).textContent);
    var s = cell.querySelector('s.compare-at-price');
    var cmpLine = s ? cents(s.textContent) : 0;
    if (isNaN(line) || isNaN(cmpLine) || !qty) return null;
    return { unit: Math.round(line / qty), cmpUnit: cmpLine ? Math.round(cmpLine / qty) : 0 };
  }

  // The cart in memory must be the one the drawer is showing (same lines):
  // if an app changed the cart without saying what is in it, it isn't.
  function matchesDrawer(c, d) {
    var dom = [];
    d.querySelectorAll('tr.cart-items__table-row[data-key]').forEach(function (r) { dom.push(r.getAttribute('data-key')); });
    var mem = c.items.map(function (it) { return it.key; });
    if (dom.length !== mem.length) return false;
    return mem.every(function (k) { return dom.indexOf(k) > -1; });
  }
  // An update that doesn't carry the cart (the gift app's, for one) means
  // the cart in memory may be out of date: read it again quietly.
  var staleTimer = null;
  document.addEventListener('cart:update', function (e) {
    var r = e.detail && e.detail.resource;
    if (isCart(r)) return;
    clearTimeout(staleTimer);
    staleTimer = setTimeout(function () { if (!window.NaliaCartBusy()) read(); }, 250);
  });

  // Can a change be drawn ahead exactly? Only with no discounts on the cart.
  function plainCart(c) {
    if (!c || !c.items) return false;
    if (c.total_discount || (c.cart_level_discount_applications || []).length) return false;
    return c.items.every(function (it) {
      return !(it.discounts || []).length && !(it.line_level_discount_allocations || []).length && it.final_price === it.original_price;
    });
  }

  // The predicted cart: one entry per line, starting from Shopify's cart.
  var P = null;
  function model(c, d) {
    return c.items.map(function (it) {
      var row = rowOf(d, it.key);
      var nums = row ? rowNumbers(row, it.quantity) : null;
      var t = TPL && TPL.byV[String(it.variant_id)];
      return {
        key: it.key, v: it.variant_id, pid: it.product_id, qty: it.quantity,
        unit: it.final_price, cmpUnit: t ? t.cmp : (nums ? nums.cmpUnit : 0),
        gift: it.final_line_price === 0, sub: !!it.selling_plan_allocation, row: row
      };
    });
  }
  function asCart(lines) {
    return { token: 'predicted', items: lines.map(function (l) {
      return { key: l.key, variant_id: l.v, product_id: l.pid, quantity: l.qty, final_line_price: l.unit * l.qty, properties: {}, selling_plan_allocation: l.sub ? {} : null };
    }) };
  }
  function savingsOf(l) { return l.cmpUnit > l.unit ? (l.cmpUnit - l.unit) * l.qty : 0; }

  // ---- drawing the prediction -----------------------------------------
  var kitV = (function () { var k = bundles.filter(function (b) { return b.id === 'kit'; })[0]; return k ? k.v : null; })();
  function dim(d, on) {
    d.querySelectorAll('.nalia-cart-sub, .nalia-plan').forEach(function (el) {
      el.style.transition = 'opacity .15s ease';
      el.style.opacity = on ? '0.45' : '';
      el.style.pointerEvents = on ? 'none' : '';
    });
  }
  function drawTotals(d, dTotal, dSavings, count) {
    var totalEl = d.querySelector('[ref="cartTotal"]');
    var total = totalEl ? cents((totalEl.querySelector('.money') || totalEl).textContent) + dTotal : NaN;
    if (!isNaN(total)) d.querySelectorAll('[ref="cartTotal"]').forEach(function (el) { setMoney(el, total); });
    // Savings line in the summary
    var sav = d.querySelector('.cart__savings');
    var cur = sav ? cents(sav.querySelector('.cart__savings-value').textContent) : 0;
    var next = cur + dSavings;
    if (sav && next <= 0) sav.remove();
    else if (sav) setMoney(sav.querySelector('.cart__savings-value'), next);
    else if (next > 0 && TPL && TPL.savings) {
      var tot = d.querySelector('.cart__total');
      if (tot) {
        var frag = document.importNode(TPL.savings.content, true);
        var el = frag.querySelector('.cart__savings');
        setMoney(el.querySelector('.cart__savings-value'), next);
        tot.parentNode.insertBefore(el, tot);
      }
    }
    // Item count (drawer heading, header bubble)
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) { el.textContent = count; });
    document.querySelectorAll('.cart-bubble__text .visually-hidden').forEach(function (el) { el.textContent = el.textContent.replace(/\d+/, count); });
    d.querySelectorAll('[ref="cartItemCount"]').forEach(function (el) { el.textContent = count; });
    // Free shipping bar: update the amount and the bar within the same state;
    // if the change crosses the threshold, wait for Shopify's redraw.
    var fs = d.querySelector('.free-shipping-progress[data-free-shipping-threshold]');
    if (fs && !isNaN(total)) {
      var th = parseInt(fs.getAttribute('data-free-shipping-threshold'), 10);
      var was = fs.classList.contains('free-shipping-progress--qualified');
      var now = total >= th;
      var fill = fs.querySelector('.free-shipping-progress__fill');
      var text = fs.querySelector('.free-shipping-progress__text');
      if (th > 0 && was === now) {
        if (!now && text) text.textContent = moneyIn(text.textContent, th - total);
        if (fill) { var pc = now ? 100 : Math.floor(total * 100 / th); fill.style.width = pc + '%'; fill.setAttribute('data-progress', pc); }
      } else {
        fs.style.opacity = '0.45';
      }
    }
  }
  function drawLine(l) {
    var row = l.row;
    if (!row) return;
    var cell = row.querySelector('.cart-items__price');
    if (cell) {
      setMoney(cell.querySelector('text-component'), l.unit * l.qty);
      var s = cell.querySelector('s.compare-at-price');
      if (s && l.cmpUnit) setMoney(s, l.cmpUnit * l.qty);
      var save = cell.querySelector('.cart-items__save-price-label');
      if (save) setMoney(save, savingsOf(l));
    }
    var input = row.querySelector('.cart-items__quantity input');
    if (input) { input.value = l.qty; input.setAttribute('value', l.qty); }
    var minus = row.querySelector('.quantity-minus');
    if (minus) minus.disabled = l.qty <= 1;
  }
  function newRow(v) {
    var t = TPL && TPL.byV[String(v)];
    if (!t) return null;
    var frag = document.importNode(t.tpl.content, true);
    return frag.querySelector('tr');
  }

  // Work out and draw one tap. Returns false if it can't be drawn exactly
  // (then the tap only shows a loading state).
  function predict(op, d) {
    if (!P) return false;
    var lines = P.lines;
    var before = { total: 0, savings: 0 };
    lines.forEach(function (l) { before.total += l.unit * l.qty; before.savings += savingsOf(l); });
    var next;
    if (op.type === 'step') {
      var keep = cart; cart = asCart(lines);
      var plan;
      try { plan = planRemove(op.key, []); } finally { cart = keep; }
      if (!plan || (!plan.add.length && !plan.remove.length)) return false;
      if (!TPL || !plan.add.every(function (v) { var t = TPL.byV[String(v)]; return t && t.ok; })) return false;
      next = lines.filter(function (l) { return plan.remove.indexOf(l.key) < 0; });
      var added = plan.add.map(function (v) {
        var t = TPL.byV[String(v)];
        return { key: 'nalia-new-' + v, v: v, pid: t.pid, qty: 1, unit: t.price, cmpUnit: t.cmp, gift: false, sub: false, row: null, fresh: true };
      });
      next = added.slice().reverse().concat(next);
    } else {
      var target = lines.filter(function (l) { return l.key === op.key; })[0];
      if (!target || target.sub || target.gift) return false;
      next = lines.map(function (l) {
        if (l !== target) return l;
        var c2 = {}; for (var k in l) c2[k] = l[k];
        c2.qty = op.type === 'rm' ? 0 : op.qty;
        return c2;
      }).filter(function (l) { return l.qty > 0; });
    }
    // The free Dewy Duo leaves with the kit.
    var hasKit = next.some(function (l) { return l.v === kitV; });
    if (!hasKit) next = next.filter(function (l) { return !(l.gift && l.row && l.row.querySelector('.nalia-free-tag')); });
    var count = 0, after = { total: 0, savings: 0 };
    next.forEach(function (l) { count += l.qty; after.total += l.unit * l.qty; after.savings += savingsOf(l); });
    if (count === 0) return false; // emptying the cart: leave it to the theme's empty state

    // Draw rows: take out rows that are gone, add new ones at the top.
    var body = rowsBody(d);
    if (!body) return false;
    lines.forEach(function (l) {
      if (l.row && next.indexOf(l) < 0 && !next.some(function (n) { return n.row === l.row; })) l.row.remove();
    });
    next.slice().reverse().forEach(function (l) {
      if (!l.row && l.fresh) {
        var r = newRow(l.v);
        if (!r) return;
        l.row = r;
        body.insertBefore(r, body.querySelector('tr.cart-items__table-row[data-key]'));
      }
    });
    next.forEach(function (l) { if (op.type !== 'step' && l.key === op.key) drawLine(l); });
    drawTotals(d, after.total - before.total, after.savings - before.savings, count);
    dim(d, true);
    P.lines = next;
    P.total = after.total;
    return true;
  }

  // ---- the save queue -------------------------------------------------
  var queue = [], running = false;
  window.NaliaCartBusy = function () { return running || queue.length > 0; };
  function lineKey(op) {
    if (!cart) return null;
    var hit = cart.items.filter(function (it) { return it.key === op.key; })[0];
    if (hit) return hit.key;
    if (op.v) {
      var byV = cart.items.filter(function (it) { return it.variant_id === op.v && it.final_line_price > 0 && !it.selling_plan_allocation; })[0];
      if (byV) return byV.key;
    }
    return null;
  }
  function exec(op) {
    return fresh().then(function () {
      if (op.type === 'step') {
        var p = planRemove(op.key, []);
        if (!p || (!p.add.length && !p.remove.length)) return cart;
        var h = pulled(); delete h[op.key]; savePulled(h);
        return save(p).catch(function () { return read().then(function () { var p2 = planRemove(op.key, []); return p2 && (p2.add.length || p2.remove.length) ? save(p2) : cart; }); });
      }
      var key = lineKey(op);
      if (!key) return cart;
      return post('/cart/change.js', withSections({ id: key, quantity: op.type === 'rm' ? 0 : op.qty }))
        .then(function (c) { cart = c; cartAt = Date.now(); return c; });
    });
  }
  function settle(c) {
    running = false;
    P = null;
    var d = drawer();
    if (d) d.querySelectorAll('[shimmer]').forEach(function (el) { el.removeAttribute('shimmer'); });
    if (c && c.sections) announce(c, 'nalia-cart');
    else post('/cart/update.js', withSections({ updates: {} })).then(function (c2) { cart = c2; cartAt = Date.now(); announce(c2, 'nalia-cart'); });
  }
  function next() {
    var op = queue.shift();
    if (!op) return;
    running = true;
    exec(op).then(function (c) {
      if (queue.length) next(); else settle(c);
    }, function () {
      queue.length = 0;
      settle(null);
    });
  }
  function enqueue(op) {
    var d = drawer();
    var drawn = false;
    if (d && TPL && cart && plainCart(cart) && TPL.currency === cart.currency) {
      // Start a prediction only from Shopify's cart with nothing pending;
      // while taps are queued, each one builds on the last prediction.
      if (!P && !window.NaliaCartBusy() && matchesDrawer(cart, d)) P = { lines: model(cart, d) };
      try { drawn = predict(op, d); } catch (e) { drawn = false; }
    }
    if (!drawn && d && cart && !window.NaliaCartBusy() && !matchesDrawer(cart, d)) read();
    if (!drawn && d) {
      // Can't draw it exactly: show it's working, Shopify's redraw follows.
      if (op.row && op.type === 'rm') op.row.style.opacity = '0.4';
      if (op.row && op.type === 'qty') {
        var qi = op.row.querySelector('.cart-items__quantity input');
        if (qi) { qi.value = op.qty; qi.setAttribute('value', op.qty); }
      }
      if (op.row) op.row.querySelectorAll('text-component').forEach(function (t) { t.setAttribute('shimmer', ''); });
      d.querySelectorAll('[ref="cartTotal"]').forEach(function (t) { t.setAttribute('shimmer', ''); });
      P = null; // later taps can't build on an unknown result
    }
    if (window.__naliaHoldDrawer) window.__naliaHoldDrawer(8000);
    queue.push(op);
    if (!running) next();
  }

  // ---- taps inside the drawer -----------------------------------------
  // Listened for on window (capture), which runs before the theme's own
  // click handling on document, so the theme doesn't also act on the tap.
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('.cart-drawer__dialog')) return;
    var row = t.closest('tr.cart-items__table-row[data-key]');
    var x = t.closest('[data-nalia-rm]');
    var plus = t.closest('.quantity-plus');
    var minus = t.closest('.quantity-minus');
    var bin = t.closest('.cart-items__remove');
    if (!x && !plus && !minus && !bin) return;
    if (!row) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var key = row.getAttribute('data-key');
    var v = parseInt(row.getAttribute('data-variant-id'), 10) || null;
    if (!v && cart) { var it = cart.items.filter(function (i) { return i.key === key; })[0]; if (it) v = it.variant_id; }
    if (x) {
      var chip = x.closest('li');
      if (chip) chip.classList.add('nalia-chip--leaving');
      enqueue({ type: 'step', key: x.getAttribute('data-nalia-rm'), row: row });
      return;
    }
    var input = row.querySelector('.cart-items__quantity input');
    var qty = parseInt(input && input.value, 10) || 1;
    if (bin) { enqueue({ type: 'rm', key: key, v: v, row: row }); return; }
    if (minus && qty <= 1) return;
    enqueue({ type: 'qty', key: key, v: v, qty: plus ? qty + 1 : qty - 1, row: row });
  }, true);

  if (!document.getElementById('nalia-chip-leaving-css')) {
    var st = document.createElement('style');
    st.id = 'nalia-chip-leaving-css';
    st.textContent = '.nalia-chip--leaving{opacity:0;transform:scale(.85);transition:opacity .18s ease,transform .18s ease;pointer-events:none}';
    document.head.appendChild(st);
  }

  window.NaliaBundles = {
    config: C,
    read: read,
    cart: function () { return cart; },
    analyse: analyse,
    planAdd: planAdd,
    planRemove: planRemove,
    canRemove: canRemove,
    add: add,
    remove: remove,
    keysFor: function (productId) { var m = byPid[productId]; return m ? m.keys.slice() : []; },
    bundleFor: function (productId) { var m = byPid[productId]; return m && m.bundle ? m.bundle : null; },
    nameOf: function (k) { return (C.names && C.names[k]) || k; }
  };
})();
